import { getClientId } from '../utilities/uuid_util';

export const getBasicParameters = () => ({
  deviceId: getClientId(),
});
